/**
 * APK-plicht detectie voor Nederlandse voertuigen.
 * Bron: RDW. Voertuigen zónder APK-plicht:
 *  - Bromfietsen / snorfietsen (Scooter <50cc, <45km/h)
 *  - Aanhangers < 750kg toegestaan maximumgewicht
 *  - Caravans (zelfde regel als aanhangers <3500kg geldt voor inspectiekeuring, niet APK)
 *  - Sommige oldtimers > 50 jaar (mits niet bedrijfsmatig vervoer)
 *
 * Override: kenteken-eigenaar kan `apkVrij: true` zetten in het voertuig-record
 * om expliciet te bevestigen dat een specifiek voertuig geen APK nodig heeft.
 */
export function isApkExempt(auto) {
  if (!auto) return false;
  if (auto.apkVrij === true) return true;
  const t = auto.voertuigType;
  if (t === 'Scooter') return true;
  if (t === 'Aanhanger') return true; // user kan manueel datum zetten voor > 750kg
  if (t === 'Caravan') return true;
  if (t === 'Oldtimer' && auto.bouwjaar && auto.bouwjaar < (new Date().getFullYear() - 50)) return true;
  return false;
}

export function apkLabel(auto, locale = 'nl') {
  if (isApkExempt(auto)) return locale === 'en' ? 'N/A' : 'N.v.t.';
  if (!auto?.apkVervalt) return '-';
  return new Date(auto.apkVervalt).toLocaleDateString(locale === 'en' ? 'en-GB' : 'nl-NL');
}
